<template>
  <v-app :dark="dark">
    <v-main class="fondo" v-if="user_id">
      <header class="app-header">
        <v-layout class="infoUser" style="height: 60px">
          <v-flex xs12>
            <UserInfo/>
          </v-flex>
        </v-layout>
        <v-layout style="height:30px">
          <v-flex xs12 class="fondo_m">
            <Title/>
          </v-flex>
        </v-layout>
      </header>
      <nav class="app-sidebar">
        <Aside class="aside"/>
      </nav>
      <div class="app-content background-color-2">
        <router-view></router-view>
        <SupportFooter />
      </div>
    </v-main>

    <SessionLoadingScreen v-else-if="sessionLoading" />

    <v-dialog v-model="dialog_exp" :width="'25%'" persistent>
			<v-card class="fullHeight pa-20">
        <div style="margin-bottom: 30px">
          <h2 class="dialogTitle">Sesión expirada</h2>
        </div>
        <br>
				<div style="text-align: center; margin-top: 30px">
					<v-btn color="primary"  @click="reload" class="ma-4">
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import UserInfo from '@/components/design/UserInfo.vue';
import Title from '@/components/design/Title.vue';
import Aside from '@/components/design/Aside.vue';
import SupportFooter from '@/components/design/SupportFooter.vue';
import SessionLoadingScreen from '@/components/design/SessionLoadingScreen.vue';
import socket from '@/components/socket';
import { getPostLoginData } from '@/functions/general.js';
import { getAccess, getRefresh } from '@/requests/ac';
import modules from '@/modules.js';

export default {
  name: 'app',
  mixins: [socket],
  components: { UserInfo, Title, Aside, SupportFooter, SessionLoadingScreen },
  data() {
    return {
      $router: this.$router,
      dialog_exp:false,
      sessionLoading: false,
    };
  },
  computed: {
    employee_name() { return this.session.user? this.session.user.employee_name: '' },
    accessRequesting() { return this.$store.getters.accessRequesting },
    dark() { return this.$store.getters.dark },

    activeRouterName(){ return this.$router.currentRoute.name },
    session_access() {return this.$store.getters.session.access},
    access() {return this.$store.getters.access}
  },
  watch:{
    'session_access'(session_access){
      if (!session_access) this.dialog_exp = true 
    },
    'access'(access){
      if (!access) this.dialog_exp = true 
    }
  },
  async created() {
    if (window.top !== window.self) window.top.location.replace(window.self.location.href);
    if (!getRefresh()) {
      this.$store.dispatch('logout')
      this.$router.push({name:'login', query: { next: this.$route.fullPath }});
      return;
    }
    if(this.user_id) this.load_data();
    else {
      this.sessionLoading = true;
      this.$store.dispatch('set', {key: 'accessRequesting', val: getAccess()});
      if (this.accessRequesting) {
        this.accessRequesting
          .then(a => {
            this.sessionLoading = false;
            if (a) {
              const {access, user/* ,refresh */} = a;
              const refresh = this.$store.getters.bs.getRefresh();
              this.$store.dispatch('assign',{key:'access', val:{time:new Date().getTime(),status:1,val:access}});
              this.$store.dispatch('set',{key:'session', val:{refresh,access, user }});
              this.load_data();
            } else {
              this.$store.dispatch('logout');
              this.$router.push({name:'login', query: { next: this.$route.fullPath }});
            } // if
          })
          .catch(e => {
            this.sessionLoading = false;
            this.getError(e);
            this.$store.dispatch('logout');
            this.$router.push({name:'login', query: { next: this.$route.fullPath }});
          })
      } else {
        this.sessionLoading = false;
      }
    }
  }, // created
  methods:{
    async load_data() { 
      const dev_div = document.getElementById('devMode');
      if (dev_div) dev_div.style.top = '60px';
      getPostLoginData();
      for (const m of modules) {
        const { default:getPostLoginData } = await import(`@/modules/${m}/getPostLoginData.js`);
        getPostLoginData();
      } // for
      this.start_socket();
    },
    reload(){
      this.$store.dispatch('logout');
      window.location.reload()
    }
  }
};
</script>

<style src='@/assets/css/all.css'></style>
<style src='@/assets/css/simple_crud.css'></style>
<style scoped>
.bg-dark{ background-color: #151515 }
.fondo_m{
  background-image: url('../assets/fondo.png');
  background-repeat: repeat-x; 
}
.app-header {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
}
.app-sidebar {
  position: fixed;
  z-index: 10;
  top: 90px;
  left: 0;
  width: 100px;
  height: calc(100vh - 90px);
  overflow: auto;
  background-color: rgb(60, 60, 60);
}
.app-sidebar .aside {
  width: 100px !important;
  min-height: 100%;
  background-color: rgb(60, 60, 60);
}
.app-content {
  padding: 110px 0 0 120px;
  width: 100%;
  min-height: 100vh;
}
</style>